module.exports = __webpack_public_path__ + "img/3.9c9e8df8.svg";